const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const ITEM_CHANNEL_VALUES = new Set(["email", "in_app"]);
const CATEGORY_VALUES = new Set([
  "all",
  "general",
  "privacy",
  "bug",
  "feature",
  "wrong_venue_info",
  "wrong_event_info",
  "other",
]);
const STATUS_VALUES = new Set([
  "all",
  "open",
  "pending",
  "in_progress",
  "resolved",
  "closed",
]);
const ASSIGNEE_VALUES = new Set(["all", "me"]);
const PRIORITY_VALUES = new Set(["all", "high"]);

export type SupportWorkbenchSearch = {
  conversation?: string;
  itemChannel?: "email" | "in_app";
  category: string;
  status: string;
  assignee: string;
  priority: string;
};

export function parseSupportWorkbenchSearch(
  search: Record<string, unknown>,
): SupportWorkbenchSearch {
  const conversation =
    typeof search.conversation === "string" && UUID_RE.test(search.conversation)
      ? search.conversation
      : undefined;
  const itemChannel =
    typeof search.itemChannel === "string" && ITEM_CHANNEL_VALUES.has(search.itemChannel)
      ? (search.itemChannel as "email" | "in_app")
      : undefined;
  const category =
    typeof search.category === "string" && CATEGORY_VALUES.has(search.category)
      ? search.category
      : "all";
  const status =
    typeof search.status === "string" && STATUS_VALUES.has(search.status) ? search.status : "all";
  const assignee =
    typeof search.assignee === "string" && ASSIGNEE_VALUES.has(search.assignee)
      ? search.assignee
      : "all";
  const priority =
    typeof search.priority === "string" && PRIORITY_VALUES.has(search.priority)
      ? search.priority
      : "all";
  return { conversation, itemChannel, category, status, assignee, priority };
}
